<template lang="pug">
.section
  .section-header
    template(v-if="mode == 0")
      h1 {{ $t("ui.voucher_redeemed") }}
    template(v-else)
      .section-header-back
        a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect(mode = mode-1)")
          i.fas.fa-arrow-left
      h1 {{ $t("ui.voucher_redeemed_detail") }}
      .section-header-breadcrumb
        .breadcrumb-item
          a(href="javascript:void(0);" @click="redirect(mode = mode-1)") {{ $t("ui.voucher_redeemed") }}
        .breadcrumb-item.active
          span {{ $t("ui.voucher_redeemed_detail") }}
  .section-body
    .row
      .col-12
        template(v-if="mode == 0")
          .card.mb-0
            .card-header
              .row.w-100
                .form-group.col-12.mb-1
                  .d-inline-block.w-50.mb-1.mr-4(v-if="!isOperator" style="max-width:350px;")
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.fa.fa-user
                      DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getList(true)" size="sm")
                  .d-inline-block.mb-1.mr-4
                    DateRangePicker(:value="dateRange" @update="getData")
                  .d-inline-block.mb-1.mr-4
                    b-input-group(size="sm").mb-1
                      b-input-group-text(slot="prepend")
                        span {{ $t('ui.on_site') }}
                      b-input-group-text(slot="append")
                        label.custom-switch
                          input.custom-switch-input(type="checkbox" v-model="onSite" @input="getListing($event, 'onSite')")
                          span.custom-switch-indicator
                  .d-inline-block.mb-1
                    b-input-group(size="sm").mb-1
                      b-input-group-text(slot="prepend")
                        span {{ $t('ui.exclude_own') }}
                      b-input-group-text(slot="append")
                        label.custom-switch
                          input.custom-switch-input(type="checkbox" v-model="excludeOwn" @input="getListing($event, 'excludeOwn')")
                          span.custom-switch-indicator
                .form-group.col-12.mb-1
                  SubmitButton(
                    icon="fa fa-search"
                    :loading="loading"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getList(true)"
                    variant="primary"
                    size="sm"
                  ).mr-2
                  jsonToExcel(v-if="voucherRedeemedList.length > 0" mode="VoucherRedeemedList" tbl="tblVoucherRedeemed" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading2").mr-2
                  voucherRedeemedExport(v-if="voucherRedeemedList.length > 0" :tbl="voucherRedeemedList" tblId="tblVoucherRedeemed")
            .card-body
              .row
                .col-10.mb-1
                  b-pagination.float-left(
                    size="sm"
                    hide-ellipsis
                    :total-rows="totalRow"
                    :per-page="getPageSize"
                    v-model="currentPage"
                    @input="changedPage($event)")
                .col-2.mb-1
                  b-input-group(:prepend="$t('ui.page_size')" size="sm")
                    b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
                .col-12(style="max-height: 70vh; overflow: hidden;")
                  .clusterize-scroll.table-responsive
                    table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                      thead.thead-light
                        tr
                          th.text-center(width="3%")
                            span #
                          th(width="7%" @click="sortOrder('domain_name')")
                            span(:title="$t('ui.domain_name')") {{ $t('ui.domain_name') }}
                            .float-right
                              i(:class="changeSortKey('domain_name')")
                          th.text-right(width="7%" @click="sortOrder('amount')")
                            span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                            .float-right
                              i(:class="changeSortKey('amount')")
                          th.text-right(width="7%" @click="sortOrder('count')")
                            span(:title="$t('ui.count')") {{ $t('ui.count') }}
                            .float-right
                              i(:class="changeSortKey('count')")
                      tbody.clusterize-content
                        tr(v-if="voucherRedeemedList.length == 0")
                          td(colspan="4").text-center
                            span {{ $t('message.no_data_available') }}
                        tr(v-for="(item, index) in voucherRedeemedList")
                          td.text-center
                            span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                          td
                            span(:title="item.domain_name")
                              b-link.text-decoration-none(href="javascript:void(0);" @click="pageMode(item.domain_name, 1)") {{ item.domain_name }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(item.amount)" :title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:title="item.count") {{ item.count }}
        template(v-else)
          voucherRedeemedDetail(ref="voucherRedeemedDetail" :id="selectedOperatorID" :date="dateRange" :domainName="selectedDomainName" :onSite="onSite")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import voucherRedeemedExport from "@/components/report/voucherRedeemedExportFull.vue";
import voucherRedeemedDetail from "@/views/report/_voucherRedeemedDetail.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    voucherRedeemedExport,
    voucherRedeemedDetail
  },
  data: () => ({
    loading: false,
    loading2: false,
    onSite: true,
    excludeOwn: false,
    searchID: null,
    voucherRedeemedList: [],
    voucherRedeemedListFull: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    sortKey: "",
    sortType: "",
    selectedOperatorID: null,
    selectedDomainName: null,
    mode: 0 // 0 = voucherredeemed , 1 = voucherredeemeddetail
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if(this.isOperator) {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.searchID = this.accountID
      } else {
        if (this.$store.getters.reportStatement.operator_id != null)
          this.searchID = this.$store.getters.reportStatement.operator_id;

        if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
          this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
          this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
        } else {
          this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
          this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        }

        if (this.$store.getters.reportStatement.on_site != null)
          this.onSite = this.$store.getters.reportStatement.on_site;

        if (this.$store.getters.reportStatement.exclude_own != null)
          this.excludeOwn = this.$store.getters.reportStatement.exclude_own;
      }

      if(this.searchID)
        this.getList(true);
    }
  },
  methods: {
    redirect(mode) {
      this.mode = mode
      this.getList(true);
    },
    pageMode(domainName, e) {
      this.selectedOperatorID = this.searchID
      this.mode = e
      this.selectedDomainName = domainName
      var vm = this
      $(document).ready(function(){
        vm.$refs.voucherRedeemedDetail.getList()
      });
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getVoucherRedeemedList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getList(true);
    },
    setReportStatementParam: function() {
      var json = {
        operator_id: this.searchID,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        on_site: this.onSite,
        exclude_own: this.excludeOwn
      };
      this.$store.dispatch("user/setReportStatementParam", json);
    },
    getList(isSearch) {
      if (this.checkDateRange()) {
        this.getVoucherRedeemedList(isSearch);
        // if (this.$helpers.showExportAll(this.dateRange) == true) {
        //   this.getVoucherRedeemedListFull(isSearch);
        // }
      } else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getListing(eventStatus, type) {
      if(type == 'onSite')
        this.onSite = eventStatus.srcElement.checked;
      else if(type == 'excludeOwn')
        this.excludeOwn = eventStatus.srcElement.checked;

      this.getList(true);
    },
    getVoucherRedeemedList: function(isSearch) {
      if (this.checkDateRange()) {
        if (isSearch) this.currentPage = 1;

        let url = ""

        if(this.onSite) url = config.voucherRedeemedOwnUrl();
        else url = config.voucherRedeemedOthersUrl();

        this.setReportStatementParam();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          exclude_own: this.excludeOwn,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.dt.length > 0) {
                    this.voucherRedeemedList = response.data.dt;
                    this.totalRow = response.data.dt.length > 0 ? this.voucherRedeemedList[0]["totalrows"] : 0
                  } else {
                    this.voucherRedeemedList = []
                    this.totalRow = 0
                  }
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getVoucherRedeemedListFull: function() {
      if (this.checkDateRange()) {
        let url = ""

        if(this.onSite) url = config.voucherRedeemedOwnUrl();
        else url = config.voucherRedeemedOthersUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          exclude_own: this.excludeOwn,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.dt.length > 0) {
                    this.voucherRedeemedListFull = response.data.dt;
                  } else {
                    this.voucherRedeemedListFull = []
                    this.totalRow = 0
                  }
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function() {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getVoucherRedeemedList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getVoucherRedeemedList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>